export const ENV_NAME = 'staging'
export const HOST_NAME = 'ops.staging.mymove.be'
export const API_URL = 'https://staging.mymove.be/ops-api'

export const FIREBASE = {
  apiKey: 'AIzaSyDk1KFkOAghGk9T3GF3YI0hhPR0Mz4LmY4',
  authDomain: 'mymove-staging.firebaseapp.com',
  projectId: 'mymove-staging',
  appId: '1:7972322512:web:4aedf82411c736f15eb2d5',
}
